import { RefreshCw } from 'lucide-react';

import { SoftCard } from '@/components/ui/soft-card';

/**
 * Setup-in-progress card for an auto-provisioned channel whose server-side
 * setup hasn't completed yet (no enabled channel row). Renders in place of
 * `ChannelSyncStatus` on the manage page — that card claims "Connected ·
 * Live · N items syncing", which was untrue for shops whose Google setup was
 * still pending (NEA-6120).
 */
export function ChannelSetupStatus({ channel }) {
	return (
		<SoftCard className="!p-5 md:!p-6">
			<div className="flex items-start gap-4">
				<div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-action-soft">
					<RefreshCw className="h-5 w-5 animate-spin text-action-soft-foreground" style={{ animationDuration: '3s' }} />
				</div>
				<div className="min-w-0 flex-1">
					<div className="flex flex-wrap items-center gap-2">
						<h3 className="text-[15px] font-bold text-foreground md:text-base">Setting up {channel.title}</h3>
						<span className="inline-flex items-center gap-1 rounded-full bg-action-soft px-2 py-0.5 text-[11px] font-semibold text-action-soft-foreground">
							In progress
						</span>
					</div>
					<p className="mt-1 text-sm text-muted-foreground">
						We&rsquo;re getting your store connected with {channel.title}. This usually completes within a few days — you
						don&rsquo;t need to do anything.
					</p>
				</div>
			</div>
		</SoftCard>
	);
}
